import { render, staticRenderFns } from "./ShareHolderChooser.vue?vue&type=template&id=e1d9f7f4"
import script from "./ShareHolderChooser.vue?vue&type=script&lang=ts"
export * from "./ShareHolderChooser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports